import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

const stored = typeof window !== 'undefined' ? window.localStorage.getItem('treejar-lang') : null;
const initial = stored === 'ru' || stored === 'en' ? stored : 'ru';

i18n.use(initReactI18next).init({
  lng: initial,
  fallbackLng: 'en',
  debug: false,
  resources: messages,
  interpolation: {
    escapeValue: false,
  },
});

if (typeof document !== 'undefined') {
  document.documentElement.lang = initial;
}

export const changeLanguage = (lang: 'en' | 'ru') => {
  i18n.changeLanguage(lang);
  if (typeof window !== 'undefined') {
    window.localStorage.setItem('treejar-lang', lang);
  }
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lang;
  }
};

export default i18n;